var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXqFooterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 366 207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168.8,39.9c5-5,5-13.1,0-18.1c-5-5-13.1-5-18.1,0L86.9,85.7L86.6,86l-0.3-0.3L22.4,21.8c-5-5-13.1-5-18.1,0 c-5,5-5,13.1,0,18.1l63.8,63.8l0.3,0.3L4.3,168.2c-5,5-5,13.1,0,18.1c2.5,2.5,5.8,3.7,9,3.7c3.3,0,6.5-1.2,9-3.7l64.2-64.2 l64.2,64.2c2.5,2.5,5.8,3.7,9,3.7c3.3,0,6.5-1.2,9-3.7c5-5,5-13.1,0-18.1l-64.2-64.2l0.3-0.3L168.8,39.9z",
    fill: "var(--primary-600-main)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M343,158.7c11.6-15.2,18.6-34.3,18.6-54.9c0-50-40.7-90.6-90.6-90.6c-50,0-90.6,40.7-90.6,90.6c0,50,40.7,90.6,90.6,90.6 c20.6,0,39.6-6.9,54.9-18.6l12.5,12.5c2.4,2.4,5.5,3.6,8.6,3.6c3.1,0,6.2-1.2,8.6-3.6c4.7-4.7,4.7-12.4,0-17.2L343,158.7z  M324.7,140.3l-26.5-26.5c-4.7-4.7-12.4-4.7-17.2,0c-4.7,4.7-4.7,12.4,0,17.2l26.5,26.5c-10.4,7.1-23,11.3-36.6,11.3 c-35.9,0-65.1-29.2-65.1-65.1s29.2-65.1,65.1-65.1c35.9,0,65.1,29.2,65.1,65.1C336,117.3,331.8,129.9,324.7,140.3z",
    fill: "var(--primary-600-main)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M360.7,157.4c-0.1-0.1-0.1-0.1-0.2-0.1c0.2-0.1,0.4-0.2,0.5-0.4c0.2-0.3,0.3-0.6,0.3-1c0-0.4-0.1-0.8-0.3-1.1 c-0.2-0.3-0.4-0.6-0.8-0.7c-0.3-0.2-0.7-0.3-1.2-0.3h-2.8v6.6h1.4v-2.4h1.3c0.2,0,0.4,0.1,0.6,0.2c0.1,0.1,0.2,0.3,0.3,0.5l0.2,1.6 h1.4l-0.2-1.8C361.3,158.1,361.1,157.7,360.7,157.4z M359.9,156.4c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.3,0.1-0.5,0.1h-1.3V155h1.3 c0.3,0,0.5,0.1,0.7,0.3c0.2,0.2,0.2,0.4,0.2,0.6C360,156.1,360,156.3,359.9,156.4z",
    fill: "var(--primary-600-main)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M358.7,150.6c-3.6,0-6.6,3-6.6,6.6c0,3.6,3,6.6,6.6,6.6c3.6,0,6.6-3,6.6-6.6C365.3,153.5,362.4,150.6,358.7,150.6z  M358.7,162.4c-2.9,0-5.2-2.3-5.2-5.2s2.3-5.2,5.2-5.2s5.2,2.3,5.2,5.2S361.6,162.4,358.7,162.4z",
    fill: "var(--primary-600-main)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXqFooterLogo);
export default __webpack_public_path__ + "static/media/XQ_FooterLogo.a2ada8b8afc177c50af99ee414dd9b80.svg";
export { ForwardRef as ReactComponent };